import { useCallback } from 'react';
import { useTheme } from 'styled-components';
import {
  Card,
  Devider,
  Flex,
  Icon,
  IconKeys,
  Spinner,
  Text,
} from 'dash-ui';

type FlexProps = React.ComponentProps<typeof Flex>;

interface IProps extends FlexProps {
  bgColor: string;
  icon: IconKeys;
  placeholderTitle?: string;
  placeholderText?: string;
  mediaKit?: boolean;
  count: number;
  countMediaKit?: number;
  loading: boolean;
}

const DashboardWidgetContainer = ({
  bgColor,
  icon,
  placeholderTitle,
  placeholderText,
  mediaKit = false,
  countMediaKit = 0,
  count,
  loading,
  ...props
}: IProps) => {
  const theme = useTheme();

  const countComponent = useCallback(() => (
    <Flex h="100%" flexDirection="column" justifyContent="flex-end">
      <Flex>
        <Flex alignItems="center" justifyContent="flex-start">
          <Flex alignItems="center">
            <Text lg bold color={theme.colors.white}>
              {count}
            </Text>
            <Icon
              ml={2}
              name={icon}
              color={theme.colors.white}
              size={20}
            />
          </Flex>
        </Flex>
        {mediaKit && (
          <>
            <Devider
              mx={3}
              orientation="vertical"
              h={26}
              color={theme.colors.setOpacity(theme.colors.white, 30)}
            />
            <Flex alignItems="center">
              <Flex alignItems="center">
                <Text lg bold color={theme.colors.white}>
                  {countMediaKit}
                </Text>
                <Icon
                  ml={2}
                  name={'filePhoto'}
                  color={theme.colors.white}
                  size={20}
                />
              </Flex>
            </Flex>
          </>
        )}
      </Flex>
      <Flex mt={2}>
        <Text md color={theme.colors.white}>
          {placeholderTitle}
        </Text>
      </Flex>
    </Flex>
  ), [theme, icon, count, mediaKit, countMediaKit, placeholderTitle])

  const notCountFoundComponent = useCallback(() => (
    <Flex h="100%" flexDirection="column" justifyContent="center">
      <Flex mb={2}>
      <Icon
        name={icon}
        mr={2}
        mt={1}
        color={theme.colors.white}
        size={20}
      />
        <Text semibold lg color={theme.colors.white}>
          {placeholderTitle}
        </Text>
      </Flex>
      <Flex>
        <Text sm color={theme.colors.white}>
          {placeholderText}
        </Text>
      </Flex>
    </Flex>
  ), [theme, icon, placeholderTitle, placeholderText])

  return (
    <Card
      bgColor={bgColor}
      borderRadius={12}
      justifyContent="flex-end"
      px={3.75}
      pos="relative"
      flexDirection="column"
      h="150px"
      w="100%"
      p={6}
      {...props}
    >
      {
        (loading) ? (
          <Spinner fullContent />
        ):
        (count > 0) ? countComponent() : notCountFoundComponent()
      }
    </Card>
  )
};

export default DashboardWidgetContainer;

